module Meevo.Plugins.Employee {
    "use strict";
    /**
    * Motes Section of Employee 
    */
    export class NotesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Employee> {

        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            modalService: Components.Modal.IModalService,
            sectionSecurityKey?:string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null,sectionSecurityKey);

        }

        addEmployeeNote() {
            return this.dataService.getTemplate('Employee', this.parentItemId, "notes");
        }


    }
}